import { API_BASE_URL } from "../utils/employeeHelpers";
import { requestJson } from "./instateamEmployeeApi";

export function getEmployeePayrollOverview(token, monthKey = "") {
  const suffix = monthKey ? `?month=${encodeURIComponent(monthKey)}` : "";

  return requestJson(`/instateam/payroll/employee/overview${suffix}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function downloadEmployeePayslip(token, payrollId) {
  const response = await fetch(
    `${API_BASE_URL}/instateam/payroll/employee/payslip/${payrollId}/download`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    let payload = { message: "Unable to download payslip." };

    try {
      payload = await response.json();
    } catch (error) {
      payload = { message: await response.text() };
    }

    const requestError = new Error(payload.message || "Unable to download payslip.");
    requestError.status = response.status;
    throw requestError;
  }

  const blob = await response.blob();
  const contentDisposition = response.headers.get("content-disposition") || "";
  const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);

  return {
    blob,
    fileName: fileNameMatch?.[1] || `payslip-${payrollId}.html`,
  };
}
